import Aos from "aos";
import React, { useEffect, useState } from "react";
import logo from "../../assets/fan3.png";
import chatIcon from "../../assets/chatIcon.png";
function Community(props) {
  const [clicked, setClicked] = useState(false);
  useEffect(() => {
    Aos.init({ duration: 3000 });
  });
  return (
    <div className="flex py-20 px-10 md:px-0 pb-1 relative md:pb-0 md:pl-[200px] 2xl:pl-[180px] w-full flex-col md:flex-row justify-between bg-[#A9B2D9]">
      <div className="w-full md:ml-[-90px] lg:ml-0">
        <img src={chatIcon} alt="" className="2xl:w-8/12" />
        <div className="flex flex-col mb-10 md:flex-col lg:flex-row items-center">
          <p className="text-[#6E6EA1] leading-6 tracking-tight mr-3 letter-spacing:-0.05em text-md md:w-full md:text-[16px] lg:text-[18px] 2xl:text-[18px] lg:w-6/12 ml-5 mt-5">
            HandiVerse Discord is exploding! Join us to get the news as soon as
            possible and follow our latest announcements. Let’s go!
          </p>
          <a
            onClick={() => {
              setClicked(true);
            }}
            href="https://discord.com/invite/ZCBgakG7Sv"
            className={`${
              clicked ? `animate-bounce` : ``
            } bg-[#646AFB] z-10 font-medium tracking-tight letter-spacing:-0.05em mt-5 text-white text-[22px] rounded-md  py-3 px-10 transition ease-in-out delay-150  hover:-translate-y-1 hover:scale-110  duration-300`}
          >
            Join our Discord
          </a>
        </div>
      </div>

      <div className="w-2/3">
        <img
          data-aos="fade"
          className="absolute bottom-0 hidden w-4/12 mt-8 2xl:w-4/12 right-5 md:block "
          src={logo}
          alt=""
        />
      </div>
      <div className="absolute bottom-0 bg-gradient-to-t to-[#8d99c800] from-[#00ffff30] h-[10%] left-0 right-0 z-0  w-full"></div>
    </div>
  );
}

export default Community;
